export enum UndoGroupsEnum {
  SET_SUBTITLES_MODE = "Set subtitles mode",
  SET_SUBTITLES_STYLE = "Set subtitles style",
  SET_SUBTITLES_ANIMATION = "Set subtitles animation",
  SET_ANIMATION = "Set animation",
}

export enum UndoLocalActionsEnum {
  SET_SUBTITLES_MODE = "subtitles-set-mode",
  SET_SUBTITLES_STYLE = "subtitles-set-style",
  SET_SUBTITLES_ANIMATION = "subtitles-set-animation",
  SET_ANIMATION = "animation-set",
}
